// extracted by mini-css-extract-plugin
export default {"message":"Error_message__zlq1r","load":"Error_load__cnu27"};